module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_gc_lb2@2x.9ea91c0e.png";